<template>
    <div class="review-rating">
        <div
            v-for="index in 5"
            :key="index"
            :class="getClassProductReviewStar(rating, index)"
            class="product-review-star"
            role="presentation"
        ></div>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    rating: number
}>()

const getClassProductReviewStar = (reviewRating: number, index: number) => ({
    'filled': reviewRating >= index,
})
</script>

<style scoped>
.review-rating {
    display: flex;
    justify-content: flex-start;

    .product-review-star {
        width: 14px;
        height: 14px;
        background: url('@/assets/star-outlined.svg') no-repeat center center;
        display: block;
        margin: 0 4px 0 0;

        &.filled {
            background: url('@/assets/star-filled.svg') no-repeat center center;
        }
    }
}
</style>
